import { Fragment } from 'react';
import { Outlet } from 'react-router-dom';

import MainNavigationBar from 'layouts/main-navigation/main-navigation';
import Header from 'layouts/header/header';

import { LayoutWrapper } from './app-layout.style';

const AppLayout = () => {
  return (
    <Fragment>
      <Header />
      <MainNavigationBar />
      <LayoutWrapper>
        <Outlet />
      </LayoutWrapper>
    </Fragment>
  );
};

export default AppLayout;
